module.exports = __webpack_public_path__ + "static/media/lg_tagline.44c7ad12.svg";